/* eslint-disable no-param-reassign */
<template>
  <div id="home_card" name="home_card" class="portlet_content">
  </div>
</template>
<script>
import * as AdaptiveCards from "adaptivecards";
import * as ACData from "adaptivecards-templating";

export default {
  name: 'PGE_CMX_00001', // eslint-disable-line vue/name-property-casing
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
//    var AdaptiveCards = require("adaptivecards");
//    var ACData = require("adaptivecards-templating");


    // Create an AdaptiveCard instance
    var adaptiveCard = new AdaptiveCards.AdaptiveCard();

    // Set its hostConfig property unless you want to use the default Host Config
    // Host Config defines the style and behavior of a card
    // adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({
    //     fontFamily: "Segoe UI, Helvetica Neue, sans-serif"
    //     // More host config options
    // });

    var dataJson = 
    {
      "@context":"http://schema.org",
      "@type":"Restaurant",
      "url":"https://www.thisisarestaurant.com",
      "name":"The Restaurant",
      "image":"https://www.example.com/image-of-some-restaurant.jpg",
      "description":"This is an example restaurant that serves American cuisine.",
      "servesCuisine":[
          "American cuisine"
      ],
      "hasMenu":{
          "@type":"Menu",
          "name":"Dine-In Menu",
          "description":"Menu for in-restaurant dining only.",
          "hasMenuSection":[
            {
                "@type":"MenuSection",
                "name":"Steak",
                "description":"How would you like your steak prepared?",
                "image":"https://contososcubademo.azurewebsites.net/assets/steak.jpg",
                "offers":{
                  "@type":"Offer",
                  "availabilityEnds":"T8:22:00",
                  "availabilityStarts":"T8:22:00"
                },
                "hasMenuSection":[
                  {
                      "@type":"MenuSection",
                      "name":"Chicken",
                      "description":"Do you have any allergies?",
                      "image":"https://contososcubademo.azurewebsites.net/assets/chicken.jpg",
                      "offers":{
                        "@type":"Offer",
                        "availabilityEnds":"T8:22:00",
                        "availabilityStarts":"T8:22:00"
                      },
                      "hasMenuItem":{
                        "@type":"MenuItem",
                        "name":"Potato Skins",
                        "description":"Small serving of stuffed potato skins.",
                        "offers":{
                            "@type":"Offer",
                            "price":"7.49",
                            "priceCurrency":"USD"
                        },
                        "suitableForDiet":"http://schema.org/GlutenFreeDiet"
                      }
                  },
                  {
                      "@type":"MenuSection",
                      "name":"Tofu",
                      "description":"Would you like it prepared vegan?",
                      "image":"https://contososcubademo.azurewebsites.net/assets/tofu.jpg",
                      "offers":{
                        "@type":"Offer",
                        "availabilityEnds":"T8:22:00",
                        "availabilityStarts":"T8:22:00"
                      },
                      "hasMenuItem":{
                        "@type":"MenuItem",
                        "name":"Pea Soup",
                        "description":"Creamy pea soup topped with melted cheese and sourdough croutons.",
                        "offers":{
                            "@type":"Offer",
                            "price":"3.49",
                            "priceCurrency":"USD"
                        }
                      }
                  }
                ]
            }
          ]
      }
    };


    var templateJson = 
    {
        "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
        "type": "AdaptiveCard",
        "version": "1.0",
        "body": [
            {
                "type": "TextBlock",
                "text": "오늘의 점심식단",
                "size": "Medium",
                "weight": "Bolder"
            },
            {
                "type": "TextBlock",
                "text": "오늘은 어떤 메뉴를 먹을까요?",
                "wrap": true
            },
            {
                "type": "ImageSet",
                "imageSize": "medium",
                "images": [
                    {
                        "type": "Image",
                        "url": "${hasMenu.hasMenuSection[0].image}"
                    },
                    {
                        "type": "Image",
                        "url": "${hasMenu.hasMenuSection[0].hasMenuSection[0].image}"
                    },
                    {
                        "type": "Image",
                        "url": "${hasMenu.hasMenuSection[0].hasMenuSection[1].image}"
                    }
                ]
            }
        ],
        "actions": [
            {
                "type": "Action.ShowCard",
                "title": "${hasMenu.hasMenuSection[0].name}",
                "card": {
                    "type": "AdaptiveCard",
                    "body": [
                        {
                            "type": "TextBlock",
                            "text": "${hasMenu.hasMenuSection[0].description}",
                            "size": "Medium",
                            "wrap": true
                        },
                        {
                            "type": "Input.ChoiceSet",
                            "id": "SteakTemp",
                            "style": "expanded",
                            "choices": [
                                {
                                    "title": "Rare",
                                    "value": "rare"
                                },
                                {
                                    "title": "Medium-Rare",
                                    "value": "medium-rare"
                                },
                                {
                                    "title": "Well-done",
                                    "value": "well-done"
                                }
                            ]
                        },
                        {
                            "type": "Input.Text",
                            "id": "SteakOther",
                            "isMultiline": true,
                            "placeholder": "Any other preparation requests?"
                        }
                    ],
                    "actions": [
                        {
                            "type": "Action.Submit",
                            "title": "OK",
                            "data": {
                                "FoodChoice": "Steak"
                            }
                        }
                    ],
                    "$schema": "http://adaptivecards.io/schemas/adaptive-card.json"
                }
            },
            {
                "type": "Action.ShowCard",
                "title": "${hasMenu.hasMenuSection[0].hasMenuSection[0].name}",
                "card": {
                    "type": "AdaptiveCard",
                    "body": [
                        {
                            "type": "TextBlock",
                            "text": "${hasMenu.hasMenuSection[0].hasMenuSection[0].description}",
                            "size": "Medium",
                            "wrap": true
                        },
                        {
                            "type": "Input.ChoiceSet",
                            "id": "ChickenAllergy",
                            "style": "expanded",
                            "isMultiSelect": true,
                            "choices": [
                                {
                                    "title": "I'm allergic to peanuts",
                                    "value": "peanut"
                                }
                            ]
                        },
                        {
                            "type": "Input.Text",
                            "id": "ChickenOther",
                            "isMultiline": true,
                            "placeholder": "Any other preparation requests?"
                        }
                    ],
                    "actions": [
                        {
                            "type": "Action.Submit",
                            "title": "OK",
                            "data": {
                                "FoodChoice": "Chicken"
                            }
                        }
                    ],
                    "$schema": "http://adaptivecards.io/schemas/adaptive-card.json"
                }
            },
            {
                "type": "Action.ShowCard",
                "title": "${hasMenu.hasMenuSection[0].hasMenuSection[1].name}",
                "card": {
                    "type": "AdaptiveCard",
                    "body": [
                        {
                            "type": "TextBlock",
                            "text": "${hasMenu.hasMenuSection[0].hasMenuSection[1].description}",
                            "size": "Medium",
                            "wrap": true
                        },
                        {
                            "type": "Input.Toggle",
                            "id": "Vegetarian",
                            "title": "Please prepare it vegan",
                            "valueOn": "vegan",
                            "valueOff": "notVegan",
                            "wrap": false
                        },
                        {
                            "type": "Input.Text",
                            "id": "VegOther",
                            "isMultiline": true,
                            "placeholder": "Any other preparation requests?"
                        }
                    ],
                    "actions": [
                        {
                            "type": "Action.Submit",
                            "title": "OK",
                            "data": {
                                "FoodChoice": "Vegetarian"
                            }
                        }
                    ],
                    "$schema": "http://adaptivecards.io/schemas/adaptive-card.json"
                }
            }
        ]
    };


    var template = new ACData.Template(templateJson);
    var card = template.expand({
      $root: dataJson
    });
    

    adaptiveCard.parse(card);

    // Render the card to an HTML element:
    var renderedCard = adaptiveCard.render();

    // And finally insert it somewhere in your page:
    var homeCard = document.getElementById("home_card");
    homeCard.appendChild(renderedCard);
    //document.body.appendChild(renderedCard);    
  },
  created() {
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
  },
};
</script>

<style scoped>
.portlet_content {
  /*height:100%;*/
  /* height:256px; */
  overflow: hidden;
}
</style>
